import React from 'react';
import { cx } from 'react-emotion';
import { withRouter } from 'react-router';
import Map from './ceska-republika.svg';
import styles, { municipalMap } from './styles';
import UpdateBlocker from '../UpdateBlocker';

class MapMunicipal extends React.Component {

	ref = React.createRef();

	componentDidMount() {
		this.setup();

		this.ref.current.addEventListener('click', this.onClick);
	}

	componentWillUnmount() {
		this.ref.current.removeEventListener('click', this.onClick);
	}

	onClick = (event) => {
		if (event.target.nodeType !== Node.ELEMENT_NODE || event.target.tagName !== 'circle') {
			return;
		}

		const id = event.target.getAttribute('data-id');

		this.props.history.push(`/obec/${id}`);
	}

	setup() {
		const svg = this.ref.current.querySelector('svg');
		this.props.cities.slice().reverse().forEach((city) => {
			const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
			circle.setAttribute('cx', city.cx);
			circle.setAttribute('cy', city.cy);
			circle.setAttribute('r', 6);
			circle.setAttribute('data-id', city.id)
			const title = document.createElementNS('http://www.w3.org/2000/svg', 'title');
			title.innerHTML = city.name;

			circle.appendChild(title);
			svg.appendChild(circle);
		})
	}

	render() {
		return <div ref={this.ref}>
			<UpdateBlocker>
				<Map className={cx(styles, municipalMap)} />
			</UpdateBlocker>
		</div>;
	}

}

export default withRouter(MapMunicipal);
